import React from 'react'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { Typography } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

export default function ModuleHeading({title,navigateTo}) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    // If the user arrived here from the sidebar deep link, the previous page was a different section (e.g., Dashboard).
    // In this case, going back in history (-1) would take them to the wrong section.
    // Instead, we should use navigateTo to go back to the top of the current section.
    if (location.state?.fromSidebar && navigateTo) {
      navigate(navigateTo);
    } else if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
    } else if (navigateTo) {
      navigate(navigateTo);
    }
  };

  return (
    <div className='flex space-x-2 items-center mb-4'>
			{navigateTo && 	<button onClick={handleBack}>
					<KeyboardBackspaceIcon />
				</button>}
       <Typography 
       variant='h6'
        sx={{fontSize: '20px', fontWeight: 600}}
       > 
				{title}
			</Typography>
    </div>
  )
}
